import { Box, Typography } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

interface Props {
  component?: "p" | "span";
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  textColor?: string;
  dangerouslySetInnerHTML?: { __html: string };
  bold?: boolean;
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
}

const Text = ({
  children,
  component = "p",
  className,
  style,
  textColor,
  dangerouslySetInnerHTML,
  bold = false,
  align = 'inherit'
}: Props) => {
  const html = dangerouslySetInnerHTML ?? (typeof children === 'string' ? { __html: children } : null);
  return (
    <Box className={`Text ${className} ${bold && 'bold'}`} sx={style}>
      {html
        ? <Typography textAlign="center" component={component} sx={{ color: textColor }} dangerouslySetInnerHTML={html} align={align} />
        : <Typography textAlign="center" component={component} sx={{ color: textColor }} align={align}>{children}</Typography>
      }
    </Box>
  );
};

export default Text;
